import * as Yup from 'yup'

import { isLocationValueFilled } from '../unitSelection'

const makeQuestionSchema = (t) =>
  Yup.object().shape({
    question: Yup.string().required(t('internal-inspections:validation.questionRequired')),
  })

const makeRoomItemSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.objectNameRequired')),
    description: Yup.string(),
    listPosition: Yup.number(),
    questions: Yup.array().of(makeQuestionSchema(t)),
    requirePhoto: Yup.boolean(),
    requireRating: Yup.boolean(),
    requireNote: Yup.boolean(),
  })

const makeRoomSchema = (t) => {
  const roomItemSchema = makeRoomItemSchema(t)

  return Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.locationNameRequired')),
    guided: Yup.boolean(),
    roomItems: Yup.array().when('guided', {
      is: true,
      then: Yup.array()
        .of(
          roomItemSchema.test(
            'require-photo-or-condition-rating',
            t('internal-inspections:validation.requirePhotoOrRating'),
            function (roomItem) {
              return roomItem.requirePhoto || roomItem.requireRating
            },
          ),
        )
        .min(1, t('internal-inspections:validation.atLeastOneObjectRequired')),
      otherwise: Yup.array()
        .of(roomItemSchema)
        .min(1, t('internal-inspections:validation.atLeastOneObjectRequired')),
    }),
  })
}

const makeValidationSchema = (t) => {
  const roomSchema = makeRoomSchema(t)

  return Yup.object().shape({
    name: Yup.string().required(t('internal-inspections:validation.inspectionNameRequired')),
    templateName: Yup.string(),
    description: Yup.string(),
    noteRequired: Yup.boolean(),
    photosRequired: Yup.boolean(),
    reviewRequired: Yup.boolean(),
    guided: Yup.boolean(),
    frequency: Yup.string(),
    attachments: Yup.array(),
    advanced: Yup.boolean(),
    locationType: Yup.string().required(t('internal-inspections:validation.locationTypeRequired')),
    locationValue: Yup.mixed()
      .required(t('internal-inspections:validation.locationValueRequired'))
      .test(
        'location-value-filled',
        t('internal-inspections:validation.locationValueRequired'),
        isLocationValueFilled,
      ),
    date: Yup.mixed()
      .nullable()
      .when('frequency', {
        is: 'time',
        then: Yup.mixed()
          .nullable()
          .required(t('internal-inspections:validation.startDateRequiredWhenTimeBased')),
        otherwise: Yup.mixed().nullable(),
      }),
    assigneeIds: Yup.array(),
    recurrenceType: Yup.string(),
    recurrenceEndDate: Yup.mixed().nullable(),
    triggerType: Yup.string()
      .nullable()
      .when('frequency', {
        is: 'trigger',
        then: Yup.string()
          .nullable()
          .required(t('internal-inspections:validation.triggerTypeRequiredWhenTriggerBased')),
        otherwise: Yup.string(),
      }),
    triggerDays: Yup.number()
      .nullable()
      .when('frequency', {
        is: 'trigger',
        then: Yup.number()
          .nullable()
          .required(t('internal-inspections:validation.triggerDaysRequiredWhenTriggerBased')),
        otherwise: Yup.number(),
      }),
    triggerCondition: Yup.string()
      .nullable()
      .when('frequency', {
        is: 'trigger',
        then: Yup.string()
          .nullable()
          .required(t('internal-inspections:validation.triggerConditionRequiredWhenTriggerBased')),
        otherwise: Yup.string(),
      }),
    rooms: Yup.array()
      .of(roomSchema)
      .when('advanced', {
        is: false,
        then: Yup.array(), // Allow empty array if advanced is false
        otherwise: Yup.array().min(
          1,
          t('internal-inspections:validation.atLeastOneLocationRequired'),
        ),
      }),
  })
}

export default makeValidationSchema
